export const translation_en = {
    back: 'Back',
    searching: 'Searching',
    rows: 'Rows',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    delete: 'Delete',
    //header
    welcome: "Welcome",
    username: 'Username / email',
    password: 'Password',
    forgotpwd: 'Forgot password',
    login: 'Login',
    logout: 'Logout',
    loginerror: 'Incorrect username or password',
    //footer
    mbkegy: 'Hungarian Biochemical Society',
    allrightsreserved: 'All rights reserved',
    mbkegy_address:'Budapest, Magyar tudósok körútja 2 H-1117 Hungary',
    //Biokem
    mbkegy_journal: 'Hungarian Biochemistry Journal',
    mbkegy_guide: 'Guide for Authors',
    mbkegy_ens: 'EndNote style for bibliography',
    mbkegy_volume: 'Volume {n}',
    mbkegy_title_march: 'March',
    mbkegy_title_jun: 'June',
    mbkegy_title_sept: 'September',
    mbkegy_title_dec: 'December',
    mbkegy_title_merged_jubilee: 'Merged Jubilee Journal',
    mbkegy_title_merged_sept_dec: 'Merged September+December',
    open_in_new_win: 'Open in new window',
    search: 'Search',
    reset: 'Clear',
    results: 'Results',
    no_result: 'No results found',
    search_biokem: 'Search within journal issues...',
    //MemberSeach
    search_member: 'Search within members...',
    member_search: 'Member search',
    name: 'Name',
    institute: 'Institute',
    address: 'Address',
    post: 'Post',
    phone: 'Workplace phonenumber',
    email: 'Workplace email',
    //NewsLetterMyAdmin
    newsletter_myadmin: 'Managing newsletters',
    newsletter_myadmin_desc: 'The Association sends newsletters on the following topics. Here, you can subscribe to or unsubscribe from newsletters related to specific topics.\nYou can change these settings at any time, allowing you to subscribe to or unsubscribe from these newsletters whenever you wish.',
    newsletter_success_up: 'Successfully subscribed to the newsletter!',
    newsletter_success_sub: 'Successfully unsubscribed from the newsletter!',
    newsletter_admin_error: 'Error occurred while saving subscription data!',
    theme: 'Theme',
    last_sent: 'Last Sent',
    subscription: 'Subscription',
    no_data: 'not sent yet',
    //log
    log_data: 'Log rows',
    col_user: 'User',
    col_todo: 'Todo',
    col_text: 'Text',
    col_date: 'Date',
    //logNewsletter
    log_newsletter_data: 'Newsletter log rows',
    col_send_batch_id: 'BatchId',
    col_newsletter_name: 'Newsletter',
    col_fullname: 'User',
    col_email: 'Email',
    col_error: 'Error',
    //galerylist
    galery_list: 'Photo galleries',
    image: 'images',
    open_galery: 'View',
    //administration
    membership_management: 'Membership Management System',
    aggregate_report: 'Aggregate Report',
    membership_report: 'Lists by membership',
    year: 'Year',
    member_count: 'Member count',
    all: 'All',
    paid: 'Paid',
    unpaid: 'Unpaid',
    dues: 'Dues sum',
    registered_sum: 'Registered sum',
    report_desc: '* Amount Paid by Year Based on <span style="color:red">the Recording Date</span>.<br />This represents the total amount paid in a given year; however, part of this amount may not correspond to the membership fee for that specific year.<br />(Retroactive Membership Fee Payments: A membership fee recorded in 2012 for the year 2011 will appear in the second-to-last column under 2011 and in the last column under 2012.)',
    //admin edit
    only_members: 'Only members',
    anew: 'New',
    edit: 'Edit',
    back_to_list: 'Back to user list',
    new_user: 'New user',
    personal_data: 'Personal data',
    workplace_data: 'Workplace data',
    membership_data: 'Membership',
    //user form
    name_prefix_label: 'Name prefix (dr., prof.,)',
    fullname_label: 'Full name',
    username_label: 'Username',
    change_password: 'Change password',
    pwd_label: 'Password',
    pwd_re_label: 'Password again',

    workspace_label: 'Workplace',
    workspace_address_label: 'Workplace Address',
    workspace_post_label: 'Position',
    workspace_phone_label: 'Workplace Phone',
    workspace_email_label: 'Workplace Email',
    user_statement_label: 'Statement',
    user_statement: "My professional data (workplace, workplace address, position, workplace phone, workplace email) can be made public on the association's website.",
    membership_stil: 'still a member',
    membership_logout: 'End Membership',
    membership_edit: 'Edit Membership',

    affiliation_amount: 'Amount',
    affiliation_exemption: 'Exemption',
    affiliation_payment: 'Payment',
    affiliation_year: 'Year',
    affiliation_cd: 'Saved',
    affiliation_pay: 'Pay',
    affiliation_saved: "Payment successfully saved!",
    affiliation_save_error: "Error while saving the payment!",
    affiliation_delete: "Payment deletion",
    affiliation_deleted: "Payment successfully deleted!",
    affiliation_delete_error: "Failed to delete payment!",
    affiliation_delete_confirm: "Are you sure you want to delete this payment?",

    tab_user_data: 'User',
    tab_membership_data: 'Membership',
    tab_myuser_data: 'My profile',
    tab_mymembership_data: 'My payments',

    edit_membership: 'Edit membership',
    membership_start: 'Membership start',
    membership_end: 'Membership end',
    membership_comment: 'Description',
    membership_exit: 'Terminate',
    membership_saved: 'Membership saved!',
    membership_save_error: 'Failed to save membership.',
    membership_terminated: 'Membership terminated!',
    membership_terminate_error: 'Failed to terminate membership!',
    user_saved: 'User data saved!',
    user_save_error: 'Failed to save user data!',
    no_membership_data: 'The user has no membership...',
    add_membership: 'Automatic membership assignment',

    error_user_registration_email_send: "Error sending notification to the new user! (User data saved!)",
    error_change_pwd_email_send: "Error sending password change email!",
    error_validation_unique_usr: "This username is already in use! Please choose a different username!",
    error_validation_fullname: "Full name is required!",
    error_validation_usr: "Username is required!",
    error_validation_usr_length: "Username must be at least 5 characters long!",
    error_validation_pwd_length: "Password must be at least 5 characters long!",
    error_validation_email: "A email address is required!",
    error_validation_institute: "Institute is required!",

    //mydata
    my_payments_and_profile: 'My Payments & Data',
    missing_payment: 'Missing Payment',

    //contentmanagement
    content_management: 'Content management',
    col_id: 'Id',
    col_content: 'Content',
    col_expiration: 'Expiration',
    col_feature: 'Feature',
    col_visible: 'Visible',
    show_old: 'Show old',
    search_content: 'Search within content',
    content_delete: 'Delete content',
    content_delete_confirm: 'Are you sure you want to delete the content?',
    content_deleted: 'Content deleted!',
    content_delete_error: 'The content cannot be deleted because it has subcontent attached!',

    //menumanagement
    feature_access_none: 'Public',
    menu_management: 'Menu management',
    col_label: 'Label',
    show_invisible: 'Show invisible',
    search_menu: 'Search within menu',
    menu_delete: 'Delete menu',
    menu_delete_confirm: 'Are you sure you want to delete the menu?',
    menu_deleted: 'Menu deleted!',
    menu_delete_error: 'The menu cannot be deleted because it has submenus attached!',

    //newsletter edit
    newsletter_management: '✉ Newsletters',
    col_name: 'Name',
    col_subject: 'Subject',
    col_count: 'Subscribers',
    newsletter_delete: 'Delete newsletter',
    newsletter_delete_confirm: 'Are you sure you want to delete the newsletter?',
    newsletter_deleted: 'Newsletter deleted!',
    newsletter_delete_error: 'Failed to delete newsletter!',
    newsletter_show_invisible: 'Show hidden newsletters',
    newsletter_subscribers: 'Addresses',
    newsletter_name: 'Newsletter',
    newsletter_subject: 'Sumbject',
    newsletter_attachments: 'Attachments',
    address_list: 'Address list',
    clear_selection: 'Clear Selection',
    address_list_name: 'Name',
    address_list_email: 'e-mail',
    newsletter_saved: 'Newsletter saved!',
    newsletter_save_error: 'Failed to save newsletter!',
    newsletter_new: 'New newsletter',
    newsletter_all_member: 'All members',
    newsletter_address_copy_from: 'Addresses copy from: ✉ ',
    newsletter_save: 'Save newsletter',
    newsletter_send_test_mail: 'Send test email',
    newsletter_send_all_mail: 'Send all mail',
    news_letter_test_email: 'Send test email to',
    news_letter_test_email_details: 'Please enter the email address where you would like to send the test email.',
    news_letter_test_email_label: 'Email address',
    news_letter_all_email: 'Send emails to',
    news_letter_all_email_confirm: 'Are you sure you want to send this newsletter?',
    news_letter_test_email_btn: 'Send test email',
    news_letter_test_email_sent: 'Test email sent!',
    news_letter_test_email_send_error: 'Failed to send test email!',

    //contentmanagement edit
    menu_parent: 'Parent',
    menu_access: 'Access',
    menu_label: 'Label',
    menu_visible: 'Visible',
    menu_file_content: 'File content',
    order_index: 'Order index',
    menu_saved: 'Menu saved',
    menu_save_error: 'Failed to save menu!',

    content_saved: 'Content saved!',
    content_save_error: 'Failed to save content!',
    content_parent: 'Parent',
    content_access: 'Access',
    content_title: 'Title',
    content_description: 'Description',
    logical_content: 'Logicaly',
    content_expired_time: 'Validation',
    content_missing_description: 'Description is required!',

    //forgot pwd
    forgot_pwd: 'Forgot Password',
    forgot_pwd_description: 'If you have forgotten your password, please enter your email address so we can send you an email with the link to reset your password.',
    forgot_pwd_email: 'Email Address',
    forgot_pwd_email_send: 'Send Email',
    forgot_pwd_sent: 'The email has been sent to this email address: ',
    forgot_pwd_send_error: 'Failed to send email to this email address: ',
    forgot_pwd_new_pwd: 'New password',
    forgot_pwd_new_pwd_re: 'New password again',
    forgot_pwd_save_pwd: 'Save password',
    forgot_pwd_saved: 'The password has been successfully changed!',
    forgot_pwd_err_missing_token: 'Missing token!',
    forgot_pwd_err_invalid_token: 'Invalid token!',
    forgot_pwd_err_used_token: 'This link has already been used for password reset!',
    forgot_pwd_err_invalid_email: 'Invalid email address!',
    forgot_pwd_err_used_email: 'This email address belongs to multiple users!',
    forgot_pwd_err_missing_email: 'You either did not provide your email address or entered a different one!',
    forgot_pwd_err_mismatch: 'The password and confirmation do not match!',

    //junior registration
    junior_registration: 'Registration for the Junior Section',
    junior_registrate: 'Registrate',
    error_registration_email_send: 'Invalid email address!',
    junior_reg_verification_email_sent: 'Registration verify email sent!',
    junior_reg_verification: 'Verify registration',
    junior_reg_verification_inprogress: 'Verify registration in progress...',
    junior_reg_verification_done: 'Verify registration done!',
    verify_error_missing_token: 'Missing token!',
    verify_error_invalid_token: 'Invalid token!',
    verify_error_used_token: 'Used token!',

    //junior mydata
    junior_mydata: 'Junior my data',
    junior_delete_myprofile: 'Delete registration',
    junior_delete_myprofile_confirm: 'Are you sure you want to delete your registration?',
    junior_statement: 'By providing my data, I consent to the Magyar Biokémia Egyesület (MBKE) sending newsletters to the email address I have provided. I acknowledge that my consent is voluntary and that I can withdraw it at any time by using the unsubscribe option in the newsletters or by deleting my registration.',
    junior_mydata_saved: 'Data saved!',
    junior_mydata_save_error: 'Failed to save data!',
    junior_mydata_deleted: 'regisytration deleted!',
    junior_mydata_delete_error: 'Failed to delete registration!',

    //junior management
    junior_management: 'Junior list',
    verified: 'Megerősítve',
    only_verified: 'Only verified',

    //access check
    access_error_login: 'Please log in to view the page!',
    access_error_access: 'You do not have permission to view the page!'
};
